/**
* Group Map function
*/
GroupMap = (function ($) {
  var GroupMap = {
    initMap: function (response, selector) {
      //map options
      var mapOptions = {
        disableDefaultUI: false,
        mapTypeControl: false,
        fullscreenControl: false,
      };
      //create map
      var map = new google.maps.Map(document.getElementById(selector), mapOptions);
      //set bounds
      var bounds = new google.maps.LatLngBounds();
      //set info window
      var infowindow = new google.maps.InfoWindow();
      //set geocoder
      var geocoder = new google.maps.Geocoder();
      //set search distance center location
      var html = '';
      if (response === 0) {
        //get queried address
        address = 'Wales';
        //get queried radius
        radius = 50;
        // hide map & list
        $('#pills-noresults').tab('show');
      } else {
        $('#pills-map').tab('show');
        //get queried address
        address = response.search_location.location;
        //get queried radius
        radius = response.search_location.radius;
      }

      /**
       * Build map
       * @param {*} response get queried data set
       * @param {*} address get queired address
       * @param {*} radius get queried radius
       */
      function buildMap(response, address, radius) {

        geocoder.geocode(
          {
            'address': address + 'Wales, UK'
          }, function (results, status) {
            if (status === 'OK') {
              if (response === 0) {
                $('#pills-map').removeClass('active');
                $('#pills-noresults').tab('show');
              } else {
                $('#pills-noresults').removeClass('active');
              }
              /**
               *  setup queried center location
               * 
              */
              map.setCenter(results[0].geometry.location);
              var startingLocation = new google.maps.Marker({
                map: map,
                position: results[0].geometry.location,
                icon: 'https://' + window.location.hostname + '/app/themes/runwales/dist/images/starter-marker.png'
              });
              var centerlatLng = [
                results[0].geometry.location.lat(),
                results[0].geometry.location.lng()
              ];
              var centerLoc = new google.maps.LatLng(centerlatLng[0], centerlatLng[1]);

              /**
               * setup group location results
               * 
               */
              var queryRadius = radius;
              //remove search query location
              delete response.search_location;
              var groupLocations = response;
              /**
               * Loop through each group
               * 
               */
              Object.keys(groupLocations).forEach(function (group) {
                //Caclulate the distance to the search query radius
                var groupLocation = new google.maps.LatLng(
                  groupLocations[group].lat,
                  groupLocations[group].lng
                );
                var distanceInkm = google.maps.geometry.spherical.computeDistanceBetween(
                  centerLoc, groupLocation
                ) * 0.000621371192;
                //If the group sits within the radius then setup markers
                if (distanceInkm < queryRadius) {
                  //Create/plot the group markers
                  var groupMarker;
                  groupMarker = new google.maps.Marker({
                    position: groupLocation,
                    map: map,
                    title: groupLocations[group].name,
                    icon: groupLocations[group].marker,
                  });
                  //set map focus
                  bounds.extend(groupMarker.position);
                  /**
                   * Create info window box when marker is clicked
                   */
                  google.maps.event.addListener(groupMarker, 'click', (function (groupMarker, i) {
                    return function () {
                      var infoWindowContent = '<div class="group-info-window background--white p-2">';
                      if (groupLocations[group].image) {
                        infoWindowContent += '<img class="mb-3" src="' + groupLocations[group].image + '" width="100%" height="auto" />';
                      }
                      if(groupLocations[group].gudied_run !== "yes"){
                      infoWindowContent += '<h4 class="text-uppercase"><strong>' + groupLocations[group].name + '</strong></h4>' +
                        '<p class="text-uppercase">' + Math.round(distanceInkm * 100) / 100 + ' miles away</p>' +
                        '<p class="text-uppercase">LOCATION: ' + groupLocations[group].meeting_place + '</p>' +
                        '<p class="text-uppercase">GROUP TYPE: ' + groupLocations[group].type + '</p>' +
                        '<p class="text-uppercase mb-3">GROUP LEVEL: ' + groupLocations[group].level_category + '</p>' +
                        '<a class="btn text-uppercase background--green btn--green color--black" href="' + groupLocations[group].url + '">MORE INFO</a>' +
                        '</div>' +
                        '</div>';
                      }else{
                        infoWindowContent += '<h4 class="text-uppercase"><strong>' + groupLocations[group].name + '</strong></h4>' +
                        '<p class="text-uppercase distance"><strong>Guide Runner</strong></p>' +
                        '<p class="text-uppercase">' + Math.round(distanceInkm * 100) / 100 + ' miles away</p>' +
                        '<p class="text-uppercase">LOCATION: ' + groupLocations[group].meeting_place + '</p>' +
                        '<p class="text-uppercase mb-3">Led By: ' + groupLocations[group].led_by + '</p>' +
                        '<a class="btn text-uppercase background--green btn--green color--black" href="' + groupLocations[group].url + '">MORE INFO</a>' +
                        '</div>' +
                        '</div>';
                      }
                      var infowindow = new google.maps.InfoWindow();
                      infowindow.setContent(infoWindowContent);
                      infowindow.open(map, groupMarker);
                    };
                  })(groupMarker));
                  /**
                   * Create HTML for the lists
                   */
                  html += '<div class="group-block background--white mt-3 pt-4 pb-4 pl-3 pr-3" data-distance="' + Math.round(distanceInkm * 100) / 100 + '">';
                  if (groupLocations[group].image) {
                    html += '<div class="col-12">';
                    html += '<img class="mb-2" src="' + groupLocations[group].image + '"style="max-height:250px;" width="100%" height="auto" />';
                    html += '</div>';
                    html += '<div class="col-12">';
                  } else {
                    html += '<div class="col-12">';
                  }

                  if(groupLocations[group].gudied_run !== "yes"){
                    html += '<h4 class="text-uppercase"><strong>' + groupLocations[group].name + '</strong></h4>' +
                      '<div><a class="btn text-uppercase background--green btn--green color--black" href="' + groupLocations[group].url + '">MORE INFO</a>' +
                      '</div>';
                  }else{
                    html += '<h4 class="text-uppercase"><strong>' + groupLocations[group].name + '</strong></h4>' +
                    '<div><a class="btn text-uppercase background--green btn--green color--black" href="' + groupLocations[group].url + '">MORE INFO</a>' +
                    '</div>';
                  }
                }
              });

              /**
               * Build map woith all markerts and start location
               */
              map.fitBounds(bounds);
              var list = document.getElementById('list');
              list.innerHTML = '';
              list.innerHTML = html;

              // Sort list view by distance
              var groupBlocks = $('.group-block');
              groupBlocks.sort(function (a, b) {
                return +$(a).data('distance') - +$(b).data('distance');
              });

              groupBlocks.appendTo(list);

            } else {
              alert('We could not find your location please try again: ' + status);
              $('#pills-noresults').tab('show');
            }
          });

      }

      buildMap(response, address, radius);

    }
  };
  return GroupMap;
})(jQuery);